import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'

import { claimActions } from '../../../redux/actions'

class Failed extends React.Component {
  componentWillUnmount() {
    const { clearRedeemState } = this.props
    clearRedeemState()
  }

  render() {
    const { intl } = this.props
    const titleLabel = intl.formatMessage({ id: 'error.global.404' })
    const clickHereLabel = intl.formatMessage({ id: 'error.global.clickHere' })
    const toReturnHomeLabel = intl.formatMessage({ id: 'error.global.toReturnHome' })
    return (
      <div aria-labelledby="failed-claim-heading">
        <Helmet>
          <title>{titleLabel}</title>
        </Helmet>
        <div className="text-justify">
          <h4 id="failed-claim-heading">
            <FormattedMessage id="error.global.tryagain.claimMyReward" />
          </h4>
          <p>
            <Link className="redirect" to="/" aria-label={`${clickHereLabel} ${toReturnHomeLabel}`}>
              <i>{clickHereLabel}</i>
            </Link>{' '}
            {toReturnHomeLabel}.
          </p>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  clearRedeemState: (...args) => dispatch(claimActions.clearRedeemState(...args)),
})

export default injectIntl(connect(null, mapDispatchToProps)(Failed))
